<div [hidden]="newBsModalRef">
  <div class="modal-header" style="padding: 40px 40px 0 40px !important;">
    <h4 class="modal-title">{{ title }}</h4>
    <button (click)="cancel()" aria-label="Close" class="modal-close" type="button">
      <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="isSeaFamily" class="search-box search-item">
      <div class="position-relative">
        <input [formControl]="searchText"
               class="form-control border-light rounded"
               matTooltip="Search within loaded stores."
               placeholder="Search within loaded stores..."
               type="search">
        <i class="uil uil-search search-icon"></i>
      </div>
    </div>
    <div *ngIf="[companies.Sea, companies.SeaIm].includes(company)" class="d-flex">
      <div *ngIf="statusList.length" class="d-flex">
        <div *ngIf="[companies.Sea].includes(company) || ([companies.SeaIm].includes(company) && isAdmin)"
             [ngClass]="{'store-container': [companies.Sea].includes(company), 'mx-store-container': [companies.SeaIm].includes(company)}">
          <div class="type-name">Store</div>
          <ng-select *ngIf="showHqPicker"
                     [closeOnSelect]="false"
                     [disabled]="storesLoading"
                     [items]="hqOptions"
                     [multiple]="true"
                     [ngModel]="selectedHqIds"
                     [virtualScroll]="true"
                     bindLabel="name"
                     bindValue="code"
                     class="mb-2"
                     placeholder="Select HQ..."
                     (ngModelChange)="onHqChange($event)">
          </ng-select>
          <div *ngIf="storeNotice" class="text-muted small mb-2">{{ storeNotice }}</div>
          <div class="item-form full-form">
            <perfect-scrollbar [style.height]="'480px'">
              <div *ngIf="showHqPicker && !selectedHqIds.length && !storesLoading" class="text-muted small">
                Select an HQ to list its stores.
              </div>
              <div *ngIf="storesLoading" class="text-muted small">Loading stores...</div>
              <div *ngIf="dealerStoreList.length" class="form-check mb-2">
                <input (change)="changeCheckAll(dealerStoreForm, 'dealerStore')" [checked]="isDealerStoreCheckAll"
                       class="form-check-input"
                       id="dealerStoreAll" type="checkbox"/>
                <label class="form-check-label" for="dealerStoreAll">All listed</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="dealerStoreForm">
                <div *ngFor="let store of dealerStoreList" class="form-check mb-2">
                  <input (change)="onStoreToggle(store.code)" class="form-check-input"
                         formControlName="{{store.code}}" id="{{store.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{store.code}}">{{ store.name }}</label>
                </div>
              </form>
            </perfect-scrollbar>
          </div>
        </div>
        <div *ngIf="[companies.Sea].includes(company)" class="customer-detail-container">
          <div class="customer-item">
            <div class="type-name">Customer Type</div>
            <div class="item-form">
              <div class="form-check mb-2">
                <input (change)="changeCheckAll(customerTypeForm, 'customer')" [checked]="isCustomerTypeCheckAll"
                       class="form-check-input"
                       id="customerAll" type="checkbox"/>
                <label class="form-check-label" for="customerAll">All</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="customerTypeForm">
                <div *ngFor="let customer of customerTypes" class="form-check mb-2">
                  <input (change)="changeCheckBoxStatus(customerTypeForm, 'customer')" class="form-check-input"
                         formControlName="{{customer.code}}"
                         id="{{customer.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{customer.code}}">{{ customer.name }}</label>
                </div>
              </form>
            </div>
          </div>
          <div *ngIf="[companies.Sea].includes(company)" class="service-item">
            <div class="type-name">Service Type</div>
            <div class="item-form">
              <div class="form-check mb-2">
                <input (change)="changeCheckAll(serviceTypeForm, 'service')" [checked]="isServiceTypeCheckAll"
                       class="form-check-input"
                       id="serviceAll" type="checkbox"/>
                <label class="form-check-label" for="serviceAll">All</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="serviceTypeForm">
                <div *ngFor="let service of serviceTypes" class="form-check mb-2">
                  <input (change)="changeCheckBoxStatus(serviceTypeForm, 'service')" class="form-check-input"
                         formControlName="{{service.code}}" id="{{service.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{service.code}}">{{ service.name }}</label>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div *ngIf="[companies.Sea].includes(company)" class="service-product-container">
          <div class="product-item">
            <div class="type-name">Product Group</div>
            <div class="item-form full-form">
              <perfect-scrollbar [style.height]="'480px'">
                <div class="form-check mb-2">
                  <input (change)="changeCheckAll(productGroupForm, 'product')" [checked]="isProductCheckAll"
                         class="form-check-input"
                         id="productAll" type="checkbox"/>
                  <label class="form-check-label" for="productAll">All</label>
                </div>
                <form (keydown.enter)="$event.preventDefault()" [formGroup]="productGroupForm">
                  <div *ngFor="let category of productCategoriesList" class="form-check mb-2">
                    <input (change)="changeCheckBoxStatus(productGroupForm, 'product')" class="form-check-input"
                           formControlName="{{category.code}}"
                           id="{{category.code}}"
                           type="checkbox"/>
                    <label class="form-check-label" for="{{category.code}}">{{ category.name }}</label>
                  </div>
                </form>
              </perfect-scrollbar>
            </div>
          </div>
        </div>
        <div
          [ngClass]="{
            'status-container': [companies.Sea].includes(company),
            'mx-status-container': [companies.SeaIm].includes(company) && isAdmin,
            'mx-status-container-for-dealer': [companies.SeaIm].includes(company) && !isAdmin
            }">
          <div class="type-name">Status</div>
          <div class="item-form">
            <div class="form-check mb-2">
              <input (change)="changeCheckAll(statusForm, 'status')" [checked]="isStatusCheckAll"
                     class="form-check-input"
                     id="statusAll" type="checkbox"/>
              <label class="form-check-label" for="statusAll">All</label>
            </div>
            <form (keydown.enter)="$event.preventDefault()" [formGroup]="statusForm">
              <div *ngFor="let status of statusList" class="form-check mb-2">
                <input (change)="changeCheckBoxStatus(statusForm, 'status')" class="form-check-input"
                       formControlName="{{status.code}}" id="{{status.code}}"
                       type="checkbox"/>
                <label class="form-check-label" for="{{status.code}}">{{ status.name }}</label>
              </div>
            </form>
          </div>
          <div *ngIf="[companies.Sea].includes(company)" class="pt-36px">
            <div class="type-name">Redo</div>
            <div class="item-form pb-94px">
              <div class="form-check mb-2">
                <input (change)="changeCheckAll(redoForm, 'redo')" [checked]="isRedoCheckAll"
                       class="form-check-input"
                       id="redoAll" type="checkbox"/>
                <label class="form-check-label" for="redoAll">All</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="redoForm">
                <div *ngFor="let redo of redoList" class="form-check mb-2">
                  <input (change)="changeCheckBoxStatus(redoForm, 'redo')" class="form-check-input"
                         formControlName="{{redo.code}}" id="{{redo.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{redo.code}}">{{ redo.name }}</label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="[companies.Seca].includes(company)" class="d-flex">
      <div *ngIf="statusList.length" class="d-flex">
        <div class="dealer-container">
          <div class="type-name">Dealer</div>
          <div class="item-form full-form">
            <perfect-scrollbar [style.height]="'480px'">
              <div *ngIf="dealerList.length" class="form-check mb-2">
                <input (change)="changeCheckAll(dealerForm, 'dealer');setStores()" [checked]="isDealerCheckAll"
                       class="form-check-input"
                       id="dealerAll" type="checkbox"/>
                <label class="form-check-label" for="dealerAll">All</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="dealerForm">
                <div *ngFor="let dealer of dealerList" class="form-check mb-2">
                  <input (change)="changeCheckBoxStatus(dealerForm, 'dealer');setStores()" class="form-check-input"
                         formControlName="{{dealer.code}}" id="{{dealer.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{dealer.code}}">{{ dealer.name }}</label>
                </div>
              </form>
            </perfect-scrollbar>
          </div>
        </div>
        <div class="state-container">
          <div class="type-name">Province</div>
          <div class="item-form full-form">
            <perfect-scrollbar [style.height]="'480px'">
              <div *ngIf="provinceList.length" class="form-check mb-2">
                <input (change)="changeCheckAll(provinceForm, 'province');setStores()" [checked]="isProvinceCheckAll"
                       class="form-check-input"
                       id="provinceAll"
                       type="checkbox"/>
                <label class="form-check-label" for="provinceAll">All</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="provinceForm">
                <div *ngFor="let province of provinceList" class="form-check mb-2">
                  <input (change)="changeCheckBoxStatus(provinceForm, 'province');setStores()"
                         class="form-check-input"
                         formControlName="{{province.code}}"
                         id="{{province.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{province.code}}">{{ province.name }}</label>
                </div>
              </form>
            </perfect-scrollbar>
          </div>
        </div>
        <div class="seca-store-container">
          <div class="type-name">Store</div>
          <div class="item-form full-form">
            <perfect-scrollbar [style.height]="'480px'">
              <div *ngIf="storeList.length" class="form-check mb-2">
                <input (change)="changeCheckAll(storeForm, 'store')" [checked]="isStoreCheckAll"
                       class="form-check-input"
                       id="storeAll" type="checkbox"/>
                <label class="form-check-label" for="storeAll">All</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="storeForm">
                <div *ngFor="let store of storeList" class="form-check mb-2">
                  <input (change)="changeCheckBoxStatus(storeForm, 'store')" class="form-check-input"
                         formControlName="{{store.code}}" id="store-{{store.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{store.code}}">{{ store.name }}</label>
                </div>
              </form>
            </perfect-scrollbar>
          </div>
        </div>

        <div class="customer-detail-container">
          <div class="customer-item">
            <div class="type-name">Request Status</div>
            <div class="item-form">
              <div class="form-check mb-2">
                <input (change)="changeCheckAll(srStatusForm, 'srStatus')" [checked]="isSrStatusCheckAll"
                       class="form-check-input"
                       id="srStatusAll" type="checkbox"/>
                <label class="form-check-label" for="srStatusAll">All</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="srStatusForm">
                <div *ngFor="let srStatus of srStatusList" class="form-check mb-2">
                  <input (change)="changeCheckBoxStatus(srStatusForm, 'srStatus')" class="form-check-input"
                         formControlName="{{srStatus.code}}"
                         id="{{srStatus.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{srStatus.code}}">{{ srStatus.name }}</label>
                </div>
              </form>
            </div>
          </div>
          <div class="service-item">
            <div class="type-name">Repair Status</div>
            <div class="item-form">
              <div class="form-check mb-2">
                <input (change)="changeCheckAll(soStatusForm, 'soStatus')" [checked]="isSoStatusCheckAll"
                       class="form-check-input"
                       id="soStatusAll" type="checkbox"/>
                <label class="form-check-label" for="soStatusAll">All</label>
              </div>
              <form (keydown.enter)="$event.preventDefault()" [formGroup]="soStatusForm">
                <div *ngFor="let soStatus of soStatusList" class="form-check mb-2">
                  <input (change)="changeCheckBoxStatus(soStatusForm, 'soStatus')" class="form-check-input"
                         formControlName="{{soStatus.code}}" id="{{soStatus.code}}"
                         type="checkbox"/>
                  <label class="form-check-label" for="{{soStatus.code}}">{{ soStatus.name }}</label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="d-flex justify-content-between w-100">
      <button (click)="clearFilter()" class="btn btn-185px btn-outline-dark" type="submit">Clear Filter</button>

      <div (isOpenChange)="onOpenChange($event)" [dropup]="true" class="btn-group" dropdown>
        <button (click)="applyFilter()" class="btn btn-226px btn-dark" type="button">Apply Filter</button>
        <button aria-controls="dropdown-dropup" class="btn dropdown-toggle wd-94px" dropdownToggle id="button-dropup"
                type="button">
          <font-awesome *ngIf="isOpen" [color]="'color-white'" [icon]="'fa-solid fa-chevron-up'"></font-awesome>
          <font-awesome *ngIf="!isOpen" [color]="'color-white'" [icon]="'fa-solid fa-chevron-down'"></font-awesome>
        </button>
        <ul *dropdownMenu [ngStyle]="{'top': isSystemFilter ? '7px' : '15px'}" aria-labelledby="button-dropup"
            class="dropdown-menu dk-dropdown-ul wd-320px"
            id="dropdown-dropup" role="menu">
          <li *ngIf="!isSystemFilter" role="menuitem"><span (click)="filterAction('rename')" class="dropdown-item">Rename Filter</span>
          </li>
          <li *ngIf="!isSystemFilter" role="menuitem"><span (click)="filterAction('delete')" class="dropdown-item">Delete Filter</span>
          </li>
          <li role="menuitem"><span (click)="filterAction('save')" class="dropdown-item">Save Filter</span></li>
        </ul>
      </div>
    </div>
  </div>
</div>
